module.exports = __webpack_public_path__ + "static/media/goods_title_zh@2x.dd079dcd.png";